<p-dialog [visible]="uploadFileVisible" (visibleChange)="onClose()"
  styleClass="z-[1000] py-0 rounded-3xl w-auto border-1 shadow-[0_0_20px_rgba(59,130,246,0.4),0_0_40px_rgba(59,130,246,0.3)] focus:outline-none"
  [focusOnShow]="false" [draggable]="false" [dismissableMask]="true" [modal]="true" [resizable]="false" [closable]="true" appendTo="body">
  <ng-template #header>
    <div class="flex justify-center items-center w-full border-b border-gray-700 px-2 sm:px-4">
      <span class="font-bold text-lg sm:text-xl md:text-2xl bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent mb-2">Upload {{singleFileMode ? 'File' : 'Files'}}</span>
    </div>
  </ng-template>
  <div class="flex flex-col justify-center gap-3 sm:gap-4 min-w-[280px] sm:min-w-[350px] md:min-w-[450px] text-gray-100 p-3 sm:p-4 md:p-6 pt-0">
    <div class="text-center mb-2">
      <p class="text-gray-300 text-base sm:text-lg mb-2">Upload {{singleFileMode ? 'file' : 'files'}} to your study</p>
      <p class="text-gray-400 text-xs sm:text-sm">Select {{singleFileMode ? 'a file' : 'one or more files'}} from your computer to upload to your study</p>
    </div>
    <div class="flex flex-col items-center p-3 sm:p-4 bg-gray-800/50 rounded-xl border border-gray-700">
      @if (selectedFiles.length === 0) {
      <label for="file-upload"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        [class.border-blue-500]="isDragging"
        [class.bg-gray-700]="isDragging"
        class="relative cursor-pointer rounded-lg p-4 sm:p-6 border-2 border-dashed border-gray-600 hover:border-blue-500 transition-all duration-200 w-full text-center">
        <div class="flex flex-col items-center justify-center">
          <ng-icon name="phosphorUpload" class="text-3xl sm:text-4xl text-blue-400 mb-3 sm:mb-4"></ng-icon>
          <p class="text-base sm:text-lg font-semibold text-gray-200">Drag & Drop your {{singleFileMode ? 'file' : 'files'}} here</p>
          <p class="text-xs sm:text-sm text-gray-400 mt-1">or click to browse</p>
        </div>
        <input #fileInput id="file-upload" class="sr-only" type="file" (change)="onFileSelected($event)" [multiple]="!singleFileMode" />
      </label>
      } @else {
      <div class="w-full">
        <div class="flex flex-col gap-2 max-h-48 sm:max-h-60 overflow-y-auto pr-1 sm:pr-2">
          @for (file of selectedFiles; track $index) {
          <div class="flex items-center justify-between bg-gray-700/50 p-2 rounded-lg">
            <div class="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
              <ng-icon name="phosphorFile" class="text-lg sm:text-xl text-gray-400 flex-shrink-0"></ng-icon>
              <p class="text-gray-200 text-xs sm:text-sm truncate">{{ file.name }}</p>
            </div>
            <button (click)="selectedFiles.splice($index, 1)" class="text-gray-400 hover:text-red-500 transition-colors flex-shrink-0 ml-2">
              <ng-icon name="phosphorX" class="text-base sm:text-lg"></ng-icon>
            </button>
          </div>
          }
        </div>

        @if (selectedFiles.length > 0) {
        <button (click)="selectedFiles = []" class="w-full text-left text-xs sm:text-sm text-blue-400 hover:underline mt-2 p-0 bg-transparent border-none">
          Clear all files
        </button>
        }
        <button
          class="w-full mt-3 sm:mt-4 btn bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-3 sm:px-4 rounded-lg transition-colors text-sm sm:text-base"
          (click)="uploadFileSubmit()">
          Upload {{ selectedFiles.length }} File(s)
        </button>
      </div>
      }
    </div>
  </div>
</p-dialog>
